import {
  IEltDocFormData,
  TEltFormData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

interface IGetPreparedFormDataForSaving {
  isDoc: boolean
  dataForSave: TEltFormData
}
export const getPreparedFormDataForSaving = ({
  isDoc,
  dataForSave,
}: IGetPreparedFormDataForSaving) => {
  if (!isDoc) {
    return dataForSave
  }

  const docFormData = dataForSave as IEltDocFormData

  if (
    !docFormData.IsBusinessPerformanceTabEnabled &&
    docFormData.BusinessPerformanceData?.length > 0
  ) {
    return {
      ...dataForSave,
      BusinessPerformanceData: [],
    }
  }

  return dataForSave
}
